export default __webpack_public_path__ + "static/media/Banner_TR1S_360x600.f908981b.png";